var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    { attrs: { id: "scanTestTubeLog" } },
    [
      _c(
        "div",
        { attrs: { slot: "search" }, slot: "search" },
        [
          _c(
            "Form",
            {
              attrs: { "label-width": 45, model: _vm.search, id: "searchForm" },
            },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "条形码", "label-width": 60 } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: 13, clearable: true },
                            on: {
                              input: function ($event) {
                                return _vm.toInt()
                              },
                            },
                            model: {
                              value: _vm.search.barCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "barCode", $$v)
                              },
                              expression: "search.barCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "姓名" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: 50, clearable: true },
                            model: {
                              value: _vm.search.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "name", $$v)
                              },
                              expression: "search.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "证件号码", "label-width": 75 } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { maxlength: 18, clearable: true },
                            model: {
                              value: _vm.search.idCard,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "idCard", $$v)
                              },
                              expression: "search.idCard",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "体检任务",
                            prop: "taskId",
                            "label-width": 75,
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { "min-width": "350px" },
                              attrs: {
                                placeholder: "体检任务",
                                clearable: "",
                                filterable: "",
                                size: "small",
                                transfer: "true",
                                "popper-append-to-body": false,
                              },
                              model: {
                                value: _vm.search.taskId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.search,
                                    "taskId",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "search.taskId",
                              },
                            },
                            _vm._l(_vm.taskList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                staticStyle: { "min-width": "350px" },
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "学校", prop: "schoolId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { "min-width": "350px" },
                              attrs: {
                                placeholder: "学校",
                                clearable: "",
                                filterable: "",
                                size: "small",
                                transfer: "true",
                                "popper-append-to-body": false,
                              },
                              model: {
                                value: _vm.search.schoolId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.search,
                                    "schoolId",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "search.schoolId",
                              },
                            },
                            _vm._l(_vm.schoolsList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                staticStyle: { "min-width": "350px" },
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { "min-width": "95px" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "status", $$v)
                                },
                                expression: "search.status",
                              },
                            },
                            _vm._l(_vm.statusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("Col", [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _vm._v("  "),
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.query },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            "header-cell-style": {
              background: "#f8f8f9",
              color: "#515a6e",
              "text-align": "center",
            },
            "row-class-name": _vm.tableRowClassName,
            "highlight-current-row": "",
            "highlight-selection-row": "",
            "row-key": "id",
            "max-height": _vm.tableHeight,
          },
          on: { "row-click": _vm.selectrow },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "barCode",
              label: "条形码",
              "min-width": "130",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "name",
              label: "姓名",
              "min-width": "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "idCard",
              label: "证件号码",
              "min-width": "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "taskName",
              label: "体检任务",
              "min-width": "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "schoolName",
              label: "学校",
              "min-width": "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "status",
              label: "状态",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "small",
                          type: row.status === 1 ? "danger" : "primary",
                          "disable-transitions": "",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            row.status == 1
                              ? "请假"
                              : row.status == 2
                              ? "取消请假"
                              : ""
                          )
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "remark",
              label: "备注",
              "min-width": "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "operator",
              label: "最后操作人",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [_vm._v(_vm._s(row.operatorAccount))]),
                    _c("div", [_vm._v(_vm._s(row.operator))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              prop: "createTime",
              label: "操作时间",
              "min-width": "180",
            },
          }),
        ],
        1
      ),
      _c("Page", {
        staticStyle: { "margin-top": "10px" },
        attrs: {
          total: _vm.pageList.total,
          current: _vm.pageList.currentPage,
          "page-size": _vm.pageList.pageSize,
          "show-elevator": "",
          "show-sizer": "",
          "show-total": "",
          "page-size-opts": [10, 30, 50, 100],
        },
        on: {
          "on-change": _vm.chagecurrent,
          "on-page-size-change": _vm.chagepagesize,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }